import { defineStore } from 'pinia'
import { fetchAdminCatalogMeta } from '@/entities/catalog/api/catalogMetaApi'

export const useAdminCatalogMetaStore = defineStore('adminCatalogMeta', {
  state: () => ({
    productTags: [],
    cuisineTypes: [],
    restaurantTags: [],
    isLoading: false,
    error: null,
    hasLoaded: false,
  }),

  actions: {
    clear() {
      this.productTags = []
      this.cuisineTypes = []
      this.restaurantTags = []
      this.isLoading = false
      this.error = null
      this.hasLoaded = false
    },

    async fetchCatalogMeta({ force = false } = {}) {
      if (this.isLoading || (this.hasLoaded && !force)) {
        return
      }

      this.isLoading = true
      this.error = null
      try {
        const meta = await fetchAdminCatalogMeta()
        this.productTags = meta.productTags
        this.cuisineTypes = meta.cuisineTypes
        this.restaurantTags = meta.restaurantTags
        this.hasLoaded = true
      } catch (error) {
        this.error = error
        this.productTags = []
        this.cuisineTypes = []
        this.restaurantTags = []
      } finally {
        this.isLoading = false
      }
    },
  },
})
